import React, { useState } from 'react'
import { Tree, TreeSelect, Input, Button } from 'antd'

import { v4 } from 'uuid'

const { DirectoryTree } = Tree

function mapAndReplaceTree (tree, key, node) {
  if (tree.length === 0) {
    return []
  }

  let newTree = tree.slice()
  newTree = newTree.map((item) => {
    if (item.key == key) {
      const children = (item.children || []).slice()
      children.push(node)
      return { ...item, children }
    } else {
      return { ...item, children: mapAndReplaceTree(item.children || [], key, node) }
    }
  })

  return newTree
}

function mapAndRemoveTree (tree, key) {
  if (tree.length === 0) {
    return []
  }

  let newTree = tree.filter((item) => item.key !== key)
  newTree = newTree.map((item) => {
    return { ...item, children: mapAndRemoveTree(item.children || [], key) }
  })

  return newTree
}

const App = (props) => {
  const [selectedKey, setSelectedKey] = useState(undefined)
  const [name, setName] = useState('')
  const [father, setFather] = useState(undefined)
  const tree = props.value

  const onAdd = () => {
    const key = v4()
    let newTree = tree.slice()

    const node = {
      title: name,
      key,
      value: key,
      isLeaf: false,
      children: []
    }

    if (father === undefined) {
      newTree.push(node)
    } else {
      newTree = mapAndReplaceTree(tree, father, node)
    }

    props.onChange(newTree)
    setName('')
    setFather(undefined)
  }

  const onDelete = () => {
    if (selectedKey !== undefined) {
      const newTree = mapAndRemoveTree(tree, selectedKey)
      props.onChange(newTree)
      setSelectedKey(undefined)
    }
  }
  const onSelect = (keys, info) => {
    if ((keys || []).length > 0) {
      setSelectedKey(keys[0])
    } else {
      setSelectedKey(undefined)
    }
  }

  return (
    <>
      <Input.Group compact style={{ width: '100%' }}>
        <Input
          placeholder='Folder name'
          style={{ width: '30%', fontFamily: 'initial' }}
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        <TreeSelect
          style={{ width: '50%' }}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          placeholder='Root'
          allowClear
          treeDefaultExpandAll
          treeData={props.value}
          onChange={setFather}
        />

        <Button type='primary' style={{ width: '10%' }} onClick={onAdd}>
          ADD
        </Button>
        <Button type='danger' style={{ width: '10%' }} onClick={onDelete} disabled={!selectedKey}>
          REMOVE
        </Button>
      </Input.Group>

      <br />
      <DirectoryTree defaultExpandAll onSelect={onSelect} treeData={props.value} />
    </>
  )
}
export default App
